import React from 'react';
import {centsToPrice} from '../utils/filters';
import {Link} from 'gatsby';

export default ({
	slug = '',
	title = '',
	mainImage,
	brand = [],
	cents = 0,
}) => (
	<Link
		className="db product-card--carousel"
		to={`/products/${slug}`}>
		<span className="db product-card__bg">
			<span className="db image size--1x1 multiply">
				<picture>
					<img
						alt={title}
						src={mainImage ? `${mainImage}?w=800&h=800&auto=format` : '/images/icon-default-product-image.svg'}
					/>
				</picture>
			</span>
		</span>
		<span className="db product-card__info pt2 pb2 pl3 pr3 tc">
			<span className="db uppercase fw--600 mb1">
				{brand.join(', ')}
			</span>
			<span className="db product-card__title fw--500 color--gray-text mb2">
				{title}
			</span>
			<span className="db domaine--medium">
				{centsToPrice(cents)}
			</span>
		</span>
	</Link>
);